import React, { useEffect } from 'react'
import { FormSectionTitle } from 'src/Libs/flow/components'
import { Box, Grid } from '@mui/material'
import { useWatch } from 'react-hook-form'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { HideDirtyStateProvider } from '../../../providers'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'
import AccordionWrapper from '../../../components/AccordionWrapper'
import { CommonEvseDeviceSettings } from './CommonEvseDeviceSettings'
import { useEvseEditor } from '../../hooks'

/** Settings for evses with the 'eebus'-category */
export const Eebus: React.FC<{ index: number }> = ({ index }) => {
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()
  const { control, trigger } = useInstallationForm()

  const [mainProtection, eebus] = useWatch({
    control,
    name: ['generalSettings.gridSettings.mainProtection', `chargingStations.eebus.${index}`],
  })

  const { isNew, brand, reference, pairingId, chargingMode, deviceId, protection, minCharge, navigationId, solarRatio } = eebus

  const { isDirty, isError, isExpanded, toggleExpanded, canPair, handlePairing, displayName, handleDelete } = useEvseEditor({
    evseType: 'eebus',
    device: eebus,
    deviceCategoryName: 'EEBus Evse',
    index,
  })

  // Revalidate when one of these values change
  useEffect(() => {
    trigger(`chargingStations.eebus.${index}`)
  }, [index, trigger, mainProtection, protection, minCharge, solarRatio, chargingMode])

  return (
    <HideDirtyStateProvider hideDirtyState={isNew}>
      <Box component={'section'} id={navigationId}>
        <AccordionWrapper
          title={<FormSectionTitle name={displayName} onClick={handleDelete} isDirty={isDirty} isError={isError} />}
          expanded={isExpanded}
          callback={toggleExpanded}
        >
          <Grid container rowSpacing={2} sx={{ mb: 4 }}>
            <CommonEvseDeviceSettings
              evseType="eebus"
              index={index}
              pairingId={pairingId}
              brand={brand}
              reference={reference}
              deviceId={deviceId}
              canEdit={canEdit}
              canPair={canPair}
              handlePairing={handlePairing}
            />
          </Grid>
        </AccordionWrapper>
      </Box>
    </HideDirtyStateProvider>
  )
}
